import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Deserialize, IJsonObject } from 'dcerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HelpCenterList } from 'src/models/help-center';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class HelpCenterService {
  /**
   * Constructor
   * @param http HTTP service
   * @param apiService - Api service to generate the path
   */
  constructor(protected http: HttpClient, private apiService: ApiService) {}

  get path(): string {
    return this.apiService.getApiUrl() + 'help-center';
  }

  get pathV2(): string {
    return this.apiService.getApiUrl() + 'v2/help-center';
  }

  getHelpCenterSettings(): Observable<HelpCenterList> {
    return this.http.get<IJsonObject>(`${this.pathV2}`).pipe(
      map((response) => {
        return Deserialize(response, () => HelpCenterList);
      })
    );
  }

  updateHelpCenterSettings(settings: unknown): Observable<any> {
    return this.http.post(`${this.path}`, { settings: settings });
  }
}
